




















































import axios from 'axios'
import * as dayjs from 'dayjs'
import { Component, Prop } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Event from '@/models/Event'
import { apiV1EventJoinPath } from '@/rails/routes'
import { QUnitType } from 'dayjs'
import User from "@/models/User"

@Component
export default class EventCard extends VueBase {
  @Prop(Object) readonly value!: Event
  @Prop(Object) readonly user!: User
  now = dayjs()
  job = ''
  jobs = ['Web系','業務系', 'インフラ系', 'その他']

  get completedEntry(): boolean {
    return this.user.events.some(event => event.id === this.value.id)
  }

  get atDays(): number {
    return this.at('day')
  }

  get atHour(): number {
    return this.at('hour') % 24
  }

  get atMinute(): number {
    return this.at('minute') % 60
  }

  get atSecond(): number {
    return this.at('second') % 60
  }

  at(unit: QUnitType): number {
    return dayjs(this.value?.date).diff(this.now, unit)
  }

  async mounted(): Promise<void> {
    this.countdown()
  }

  countdown(): void {
    setTimeout(() => {
      this.now = dayjs()
      this.countdown()
    }, 1000)
  }

  async join(): Promise<void> {
    const res = await axios.post(apiV1EventJoinPath(this.value.id))
    window.location.href = res.data.enterUrl
  }
}
